import { render, staticRenderFns } from "./NormalSearchNav133.vue?vue&type=template&id=067d2980&scoped=true"
import script from "./NormalSearchNav133.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav133.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067d2980",
  null
  
)

export default component.exports